<script>
  import {calcPercent, parseNumber, showIntValue} from "../../Common/tools";
  import {External, M} from "../../external";
  import {getCampaignSalesTotals, VOICE, WHATSAPP} from "../../Campaign/static";
  import {onMount} from "svelte";
  import {getLists, getSegments} from "../../Campaign/Messages/static";
  import {EMPTY_SALES_TOTALS, getSalesCountLabel} from "../../Store/static";

  export let data;

  let lists, segments;
  let salesTotals = EMPTY_SALES_TOTALS;

  onMount(async () => {
    function filterList(selectedLists, allLists) {
      let list = [];
      for (let i = 0; i < selectedLists.length; i++) {
        let item = External.getById(allLists, selectedLists[i].id);
        if (item) {
          item.isExcluded = selectedLists[i].excluded;
          list.push(item);
        }
      }
      return list;
    }

    getLists(function (result) {
      lists = filterList(data.data.lists, result);
    });

    getSegments(function (result) {
      segments = filterList(data.data.segments, result);
    });

    if (data.data.salesUtm) {
      salesTotals = await getCampaignSalesTotals(data);
    }
  });

</script>

<div class="flex col20 f-left store-section-analytics-warapper three-columns flex-col-mobile mt-10" style="background: rgb(245, 246, 250);">
  <div class="analytics-box analytics-box-small" style="width: 100%">
    <h3>{M.AUDIENCE}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{showIntValue(data, "send")}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small" style="width: 100%">
    <h3>{M.LISTS}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{data.data.lists.length}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small" style="width: 100%">
    <h3>{M.SEGMENTS}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{data.data.segments.length}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small" style="width: 100%">
    <h3>{M.TYPE}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{External.CRM_MESSAGE_CHANNEL.getChannelName(data.content.channel)}</b></h2>
  </div>
  {#if data.data.salesUtm}
    <div class="analytics-box analytics-box-small" style="width: 100%">
      <h3>{M.PURCHASED}</h3>
      <h2 class="col20 f-left f-28 gray-text">
        <b>
          {External.Tools.currencyToStrWithSymbol(salesTotals.sales)}
          <span class="increase">
            ({salesTotals.orders})
          </span>
        </b>
      </h2>
    </div>
  {/if}
</div>

{#if data.data.salesUtm}
  <div class="flex f-left col9n mt-25">
    <div class="analytics-box-small" style="padding-right: 0; width: 100%;">
      <h2 class="col20 f-left f-28 gray-text">{M.MESSAGE_FLOW}</h2>
      <div class="chart-wrapper col20 f-left mt-35">
        <div class="horizontal-chart-wrapper flex align-center">
          <h4>{M.SENT}</h4>
          <div class="horizontal-chart-progress">
            <div class="horizontal-chart-progress-inner" style="width:100%;"><span class="chart-label">{parseNumber(data.data.audience)} - 100%</span></div>
          </div>
        </div>
        <div class="horizontal-chart-wrapper flex align-center">
          <h4>{M.PURCHASED}</h4>
          <div class="horizontal-chart-progress">
            <div class="horizontal-chart-progress-inner" style={"width:" + calcPercent(salesTotals.orders, data.data.audience) + "; background-color: #76bd65"}>
              <span class="chart-label">{calcPercent(salesTotals.orders, data.data.audience)} - {External.Tools.currencyToStrWithSymbol(salesTotals.sales)} ({getSalesCountLabel(salesTotals.orders)})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

{#if lists?.length}
  <div class="flex f-left col9n mt-25 compact-list-wrapper">
    <div class="analytics-box" style="width: 100%">
      <h2 class="col20 f-left f-21 mb-15 gray-text">{M.LISTS}</h2>
        {#each lists as list}
          <div class="email-list-wrapper flex align-center {list.isExcluded ? 'excluded-list' : ''}">
            <h5 class="flex-1">{list.name}</h5>
            <div class="justify-flex-end ml-25">
              <span class="email-list-number">{list.subscribers || 0}</span>
              <span class="list-exclude">{list.isExcluded ? M.EXCLUDED : M.INCLUDED}</span>
            </div>
          </div>
        {/each}
    </div>
  </div>
{/if}

{#if segments?.length}
  <div class="flex f-left col9n mt-25 compact-list-wrapper" style="margin-left: 4%;">
    <div class="analytics-box" style="width: 100%">
      <h2 class="col20 f-left f-21 mb-15 gray-text">{M.SEGMENTS}</h2>
      {#each segments as segment}
        <div class="email-list-wrapper flex align-center {segment.isExcluded ? 'excluded-list' : ''}">
          <h5 class="flex-1">{segment.name}</h5>
          <div class="justify-flex-end ml-25">
            <span class="email-list-number">{segment.subscribers || 0}</span>
            <span class="list-exclude">{segment.isExcluded ? M.EXCLUDED : M.INCLUDED}</span>
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}

<div class="flex f-left col20 mt-25">
  <div class="analytics-box mb-35" style="width: 100%">
    <h2 class="col20 f-left f-21 mb-15 gray-text">{M.MESSAGE}</h2>
    <div class="col20 f-left" style="box-sizing: border-box; font-size: 16px; line-height: 1.6">
      {data.content.body || '-'}
    </div>
    {#if data.content.attachments?.length}
      <h2 class="col20 f-left f-21 mt-25 mb-15 gray-text">{M.ATTACHMENTS}</h2>
      <div class="col20 f-left" style="box-sizing: border-box; font-size: 16px; line-height: 1.6">
        {#each data.content.attachments as attachment, i} <!--we currently only allow 1 attachment, but we can add more-->
          {#if data.type === WHATSAPP}
            <a href="{External.getFileFromBase(attachment.base) + attachment.name + '?format=webp'}" target="_blank" rel="noreferrer">
              <img alt="" class="whatsapp-attachment whatsapp-image-attachment" src="{External.getFileFromBase(attachment.base) + attachment.name + '?format=webp'}">
            </a>
          {:else if data.type === VOICE}
            <a href="{attachment.url}" class="text-link blue-text" target="_blank" rel="noreferrer">
              <span style='display: flex;'>
                <svg class='f-left' fill='#000000' width='24px' height='24px' viewBox='0 0 1920.00 1920.00' xmlns='http://www.w3.org/2000/svg' stroke='#000000' stroke-width='0.019200000000000002'><g id='SVGRepo_bgCarrier' stroke-width='0'></g><g id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round' stroke='#CCCCCC' stroke-width='49.92'></g><g id='SVGRepo_iconCarrier'> <path d='M1129.432 113v1694.148H903.545l-451.772-451.773V564.773L903.545 113h225.887Zm542.545 248.057C1832.017 521.097 1920 733.882 1920 960.107c0 226.226-87.983 438.898-248.023 598.938l-79.851-79.85c138.694-138.582 214.93-323.018 214.93-519.087 0-196.183-76.236-380.506-214.93-519.2ZM338.83 564.773v790.602H169.415C75.672 1355.375 0 1279.703 0 1185.96V734.187c0-93.742 75.672-169.414 169.415-169.414H338.83Zm1093.922 36.085c95.776 97.018 148.407 224.644 148.407 359.16 0 134.628-52.631 262.253-148.407 359.272l-80.303-79.174c74.656-75.897 115.767-175.4 115.767-280.099 0-104.585-41.111-204.088-115.767-279.986Z' fill-rule='evenodd'></path> </g></svg>
                <span class='f-left ml-10'>{attachment.url.substring(attachment.url.lastIndexOf('/') + 1)}</span>
              </span>
            </a>
          {/if}
        {/each}
      </div>
    {/if}
  </div>
</div>
